import { createFileRoute } from '@tanstack/react-router';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { MessagesApp } from '@mews-commander/modules/src/modules/messages';
import { CommunicationHub } from '@mews-commander/modules/src/modules/messagesNew';
import { MewsTeam, RouteType } from '@mews/enums';
import { useFeatureFlag } from '@mews/framework';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/MessageThread/Detail/$id')({
    component: Component,
    staticData: {
        title: TextKey.MessagePlural,
        owner: MewsTeam.Accounts,
        type: RouteType.Frontend,
    },
});

function Component() {
    const communicationHubPageEnabled = useFeatureFlag(FeatureFlag.communicationHubEnabled);
    const { id } = Route.useParams();
    return communicationHubPageEnabled ? <CommunicationHub /> : <MessagesApp initialThreadId={id} />;
}
